import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import { Box, Tooltip } from "@mui/material";
import StyledSimpleBar from "./StyledSimpleBar";
import AnimationAction from "./AnimationAction";
import { useTheme } from "@mui/material/styles";
import { reorderObjects } from "../reducers/slices/phases.js";
import { useDispatch } from "react-redux";

export default function ActionTimeline(props) {
  const dispatch = useDispatch();
  const { steps, goToTimestamp } = props;
  const theme = useTheme();
  return (
    <>
      <Box sx={{ fontWeight: 600, marginBottom: 1.5 }}>
        Action Timeline
        <Tooltip
          enterDelay={200}
          placement="top"
          arrow
          title="Reorder Actions using Drag & Drop"
        >
          <FontAwesomeIcon
            style={{ cursor: "pointer", marginLeft: 5 }}
            icon={faCircleQuestion}
          />
        </Tooltip>
      </Box>
      {steps.length === 0 && (
        <Box sx={{ fontSize: 12 }}>
          Add Actions in the "Draw" tab to start animating your play.
        </Box>
      )}
      <Box
        sx={{
          position: "relative",
          flex: 1,
          marginBottom: 5,
          [theme.breakpoints.up("md")]: {
            marginBottom: 0,
          },
        }}
      >
        <Box
          sx={{
            [theme.breakpoints.up("md")]: {
              position: "absolute",
              inset: 0,
            },
          }}
        >
          <StyledSimpleBar
            autoHide={false}
            sx={{
              height: "100%",
              [theme.breakpoints.up("md")]: {
                marginRight: -2,
                paddingRight: 2,
              },
            }}
          >
            <DragDropContext
              onDragEnd={(x) => {
                if (!x.destination) return;
                dispatch(
                  reorderObjects({
                    newIndex: x.destination.index,
                    oldIndex: x.source.index,
                  })
                );
              }}
            >
              <Droppable direction="vertical" droppableId="droppable">
                {(provided, snapshot) => (
                  <Box
                    sx={{
                      backgroundColor:
                        steps.length > 0 ? "rgb(235, 236, 240)" : "transparent",
                      p: 0.8,
                      pb: 0,
                    }}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {steps.map((step, index) => {
                      return (
                        <Draggable
                          key={step.action.id}
                          draggableId={step.action.id.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                            >
                              <AnimationAction
                                onClick={() => goToTimestamp(index)}
                                dragHandleProps={provided.dragHandleProps}
                                step={step}
                              />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </StyledSimpleBar>
        </Box>
      </Box>
    </>
  );
}
